module.exports = __webpack_public_path__ + "img/thumbnail_StripedHyena_m_normal.7012480a.png";